import * as R from 'ramda'
import { EMPTY, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import initHotjar from 'config/initHotjar'
import {
  getHasHotjarConsent,
  getHasMixPanelConsent,
  getOneTrustTrackingConsentsFromCookie
} from 'domain/oneTrust.ts'
import * as Actions from 'store/actions/index.ts'
import {
  getCountryCode,
  getCultureCode,
  getIsHotjarFeatureEnabled
} from 'store/selectors'
import googleTags from 'tracking/googleTags'
import facebookPixel from 'tracking/facebookPixel'

const isName = R.propEq('name')
const findName = name => R.find(isName(name))

const initTrackingEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.tracking.TRACKING_INIT),
  switchMap((action) => {
    const { payload: { trackers } } = action
    const state = state$.value
    const isHotjarEnabled = getIsHotjarFeatureEnabled(state)
    const i18nProperties = {
      Country: getCountryCode(state),
      Language: getCultureCode(state)
    }

    const consents = getOneTrustTrackingConsentsFromCookie()

    const hasMixPanelConsent = getHasMixPanelConsent(consents)
    const hasHotjarConsent = getHasHotjarConsent(consents)

    const facebookTracker = findName('facebook')(trackers)
    const googleTrackerAW = findName('AWGoogle')(trackers)
    const googleTrackerDC = findName('DCGoogle')(trackers)
    const mixPanelTracker = findName('mixpanel')(trackers)
    const callQueue = []

    if (facebookTracker && facebookTracker.isActive && facebookTracker.token) {
      facebookPixel.init(facebookTracker.token)
    } else {
      callQueue.push(Actions.tracking.onDisableFacebookTracking())
    }

    if (
      (googleTrackerAW && googleTrackerAW.isActive) ||
      (googleTrackerDC && googleTrackerDC.isActive)
    ) {
      googleTags.init(
        googleTrackerAW.isActive ? googleTrackerAW : undefined,
        googleTrackerDC.isActive ? googleTrackerDC : undefined
      )
    } else {
      callQueue.push(Actions.tracking.onDisableGoogleTracking())
    }

    if (hasMixPanelConsent && mixPanelTracker && mixPanelTracker.isActive && mixPanelTracker.token) {
      callQueue.push(Actions.tracking.onInitMixPanel(i18nProperties, mixPanelTracker))
    } else {
      callQueue.push(Actions.tracking.onDisableMixPanelTracking())
    }

    if (hasHotjarConsent && isHotjarEnabled) {
      initHotjar()
    }

    return callQueue.length ? of(...callQueue) : EMPTY
  })
)

export default initTrackingEpic
